/* SultryStreet browsing helpers: endless scroll on product lists, a live order deadline, recently viewed products, the back-to-top button and the small email offer. All of it is built on real dates and real products. */
(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var sv = (document.documentElement.lang || 'sv').indexOf('sv') === 0;
  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text) e.textContent = text;
    return e;
  }
  function store(key, value) {
    try {
      if (value === undefined) return localStorage.getItem(key);
      localStorage.setItem(key, value);
    } catch (err) { return null; }
    return null;
  }

  /* Endless scroll. The numbered links stay in the page for search engines and as the fallback when a fetch fails. */
  function endless() {
    var pager = document.querySelector('.nb-pagination');
    var grid = pager && pager.previousElementSibling;
    if (!grid || !grid.classList.contains('nb-grid')) return;
    var next = Array.prototype.find.call(pager.querySelectorAll('a'), function (a) { return a.textContent.indexOf('→') >= 0; });
    if (!next || !('IntersectionObserver' in window)) return;
    var url = next.href, busy = false;
    var more = el('button', 'nb-more-btn', sv ? 'Visa fler' : 'Show more');
    more.type = 'button';
    pager.hidden = true;
    pager.after(more);
    function load() {
      if (busy || !url) return;
      busy = true;
      more.disabled = true;
      fetch(url).then(function (r) {
        if (!r.ok) throw new Error('page');
        return r.text();
      }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nextPager = doc.querySelector('.nb-pagination');
        var nextGrid = nextPager && nextPager.previousElementSibling;
        if (!nextGrid) throw new Error('grid');
        Array.prototype.forEach.call(nextGrid.children, function (card) { grid.append(document.importNode(card, true)); });
        var link = Array.prototype.find.call(nextPager.querySelectorAll('a'), function (a) { return a.textContent.indexOf('→') >= 0; });
        url = link ? new URL(link.getAttribute('href'), location.href).href : null;
        busy = false;
        more.disabled = false;
        if (!url) { observer.disconnect(); more.remove(); }
      }).catch(function () {
        observer.disconnect();
        more.remove();
        pager.hidden = false;
      });
    }
    more.addEventListener('click', load);
    var observer = new IntersectionObserver(function (e) { if (e[0].isIntersecting) load(); }, { rootMargin: '700px 0px' });
    observer.observe(more);
  }

  /* The real order deadlines from the shipping promise. The bar goes away by itself once they have passed. */
  function deadline() {
    var bar = document.querySelector('[data-nb-deadline]');
    if (!bar) return;
    /* Sweden: 8-14 working days. US: up to 10 business days from the international warehouse. */
    var xmas = new Date(sv ? '2026-11-28T23:59:00+01:00' : '2026-12-09T23:59:00-08:00').getTime();
    var nye = new Date(sv ? '2026-12-02T23:59:00+01:00' : '2026-12-15T23:59:00-08:00').getTime();
    function paint() {
      var now = Date.now(), target = now <= xmas ? xmas : now <= nye ? nye : 0;
      if (!target) { bar.hidden = true; return; }
      var left = target - now, h = Math.floor(left / 3600000), d = Math.floor(h / 24);
      var mins = Math.floor(left / 60000);
      var span = sv
        ? (h >= 48 ? d + ' dagar' : h >= 1 ? h + ' tim ' + mins % 60 + ' min' : mins + ' min')
        : (h >= 48 ? d + ' days' : h >= 1 ? h + ' hr ' + mins % 60 + ' min' : mins + ' min');
      bar.replaceChildren();
      var a = el('a', '', sv
        ? 'Beställ inom ' + span + ' för leverans före ' + (target === xmas ? 'jul' : 'nyår') + ' →'
        : 'Order within ' + span + ' for delivery before ' + (target === xmas ? 'Christmas' : 'New Year') + ' →');
      a.href = root + 'collections/' + (sv ? (target === xmas ? 'julklanningar' : 'nyarsklanningar') : 'dresses');
      bar.append(a);
      bar.hidden = false;
    }
    paint();
    setInterval(paint, 60000);
  }

  /* Recently viewed, kept in this browser only. The home page leaves out underwear and bodies. */
  function recent() {
    var handles = [];
    try { handles = JSON.parse(store('ss-seen') || '[]'); } catch (err) { handles = []; }
    var m = location.pathname.match(/\/products\/([^/?#]+)/);
    var here = m && m[1];
    if (here) store('ss-seen', JSON.stringify([here].concat(handles.filter(function (h) { return h !== here; })).slice(0, 12)));
    var list = handles.filter(function (h) { return h !== here; }).slice(0, 6);
    var isHome = !!document.querySelector('.ad-home');
    var rows = document.querySelectorAll('[data-nb-pdp] .nb-related');
    var anchor = isHome ? document.querySelector('.ss-jul-shelf') : here && rows[rows.length - 1];
    if (!anchor || list.length < 2) return;
    Promise.all(list.map(function (h) {
      return fetch(root + 'products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (items) {
      items = items.filter(function (p) {
        if (!p || !p.available) return false;
        return !(isHome && (p.type === 'Underkläder' || p.type === 'Bodysuits' || (p.tags || []).indexOf('Hygien') >= 0));
      });
      if (items.length < 2) return;
      var box = el('section', 'nb-container nb-shop-section ss-seen');
      if (!isHome) box.className = 'nb-related ss-seen';
      var head = el('div', 'nb-shop-head');
      var wrap = el('div');
      wrap.append(el('h2', '', sv ? 'Du tittade nyss på' : 'Recently viewed'));
      head.append(wrap);
      var row = el('div', 'nb-grid ss-swipe');
      items.forEach(function (p) {
        var card = el('article', 'nb-card');
        var link = el('a', 'nb-card-link');
        link.href = p.url;
        var media = el('div', 'nb-card-media');
        if (p.featured_image) {
          var img = el('img', 'nb-card-img');
          img.loading = 'lazy';
          img.alt = p.title;
          img.src = p.featured_image + (p.featured_image.indexOf('?') < 0 ? '?' : '&') + 'width=480';
          media.append(img);
        }
        link.append(media, el('h3', 'nb-card-title', p.title), el('p', 'nb-card-price', sv ? Math.round(p.price / 100) + ' kr' : '$' + (p.price / 100).toFixed(2)));
        var buy = el('button', 'nb-quick', sv ? 'Lägg i varukorg' : 'Add to cart');
        buy.type = 'button';
        buy.dataset.nbQuick = p.handle;
        card.append(link, buy);
        row.append(card);
      });
      box.append(head, row);
      anchor.after(box);
    });
  }

  function backToTop() {
    if (document.querySelector('[data-nb-pdp]')) return;
    var b = el('button', 'nb-top', '↑');
    b.type = 'button';
    b.hidden = true;
    b.setAttribute('aria-label', sv ? 'Till toppen' : 'Back to top');
    b.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
    document.body.append(b);
    addEventListener('scroll', function () { b.hidden = scrollY < 1400; }, { passive: true });
  }

  /* Email offer: after 30 seconds or half the page, once, and away for 14 days when closed. */
  function offer() {
    var card = document.querySelector('[data-nb-offer]');
    if (!card) return;
    var close = card.querySelector('[data-nb-offer-close]');
    if (close) close.addEventListener('click', function () { card.hidden = true; store('ss-offer', String(Date.now())); });
    /* Just sent: keep the thank-you or the error in view, and do not ask again for 14 days. */
    if (card.querySelector('[data-nb-offer-open]')) {
      card.hidden = false;
      store('ss-offer', String(Date.now()));
      return;
    }
    if (Date.now() - Number(store('ss-offer') || 0) < 14 * 864e5) return;
    function show() {
      if (document.querySelector('dialog[open]')) return;
      card.hidden = false;
      removeEventListener('scroll', onScroll);
    }
    function onScroll() {
      if (scrollY > (document.documentElement.scrollHeight - innerHeight) / 2) show();
    }
    addEventListener('scroll', onScroll, { passive: true });
    setTimeout(show, 30000);
  }

  function start() {
    endless();
    deadline();
    recent();
    backToTop();
    offer();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
